import { JiraProductDiscoveryIcon } from '@atlaskit/logo';
import { whyAmISeeingThisRecommendationMessageDefaultReason } from '@post-office/components--ad-controls';
import { JiraSideNavFirstPartyRecommendation } from '@post-office/components--jira-side-nav-first-party-recommendation';
// @ts-expect-error: 'React' is declared but its value is never read
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { createRender } from './types';
import { type JSX } from 'react/jsx-runtime';

const CCP_PRODUCT_ID = 'a6f908c8-709c-45f4-9e2d-eca25b93b94a';
const HAMS_PRODUCT_ID = 'jira-product-discovery';
const PRODUCT_NAME = 'Jira Product Discovery';

const whyAmISeeingThisModalContent = {
	message: (
		<p>
			<FormattedMessage
				id="growth.recommendation-jpd.reasons-modal.message"
				defaultMessage="We think {jpd} will improve your team's productivity. The recommendation is based on:"
				description="Explanation of why we think the JPD recommendation will be relevant to the customer."
				values={{ jpd: <strong>{PRODUCT_NAME}</strong> }}
			/>
		</p>
	),
	reasons: whyAmISeeingThisRecommendationMessageDefaultReason,
};

export type Props = {
	onDismissed: (messageInstanceId: string) => void;
};

export const render: (renderProps: { onDismissed: () => void }) => JSX.Element | null =
	createRender(({ onDismissed }: Props) => (
		<JiraSideNavFirstPartyRecommendation
			app={{
				hamsIdentifier: HAMS_PRODUCT_ID,
				ccpProductId: CCP_PRODUCT_ID,
				logo: <JiraProductDiscoveryIcon appearance="brand" />,
				header: (
					<FormattedMessage
						id="growth.recommendation-jpd.product-name.header"
						description="Header for Jira Product Discovery recommendation message in Jira Side Nav"
						defaultMessage="Transform insights into action plans"
					/>
				),
				ctaMessage: (
					<FormattedMessage
						id="growth.recommendation-jpd.cta.label"
						description="CTA text for Jira Product Discovery recommendation message in Jira Side Nav"
						defaultMessage="Try Jira Product Discovery"
					/>
				),
			}}
			onDismissed={onDismissed}
			whyAmISeeingThisModalContent={whyAmISeeingThisModalContent}
		/>
	));

export default render;
